// extracted by mini-css-extract-plugin
export var displayNone = "_rn-6";
export var imgContainer = "_rn-2";
export var overflowHidden = "_rn-3";
export var productInfoCardButtonContainer = "_rn-5";
export var productTitleText = "_rn-4";
export var rightArrow = "_rn-1";
export var rightArrowContainer = "_rn-0";